export class Customer {
  customerId: string;
  customerName: string;
}
